import React, { useEffect, useState } from 'react'
import styles from './editor__toolbar_right.jcss'
import translate from '../../../../core/translate'
import Dropdown from '../../../../blocks.simple/dropdown/dropdown'
import { SelectTime } from '../../../scheduleSettings/scheduleSettings'
import Button from '../../../../blocks.simple/button/button'
import { editor } from '../../editor.local.methods'

export const ContentFrequency = ({ p_, onClose }) => {
    const [playback, setPlayback] = useState('fromStartToEnd')
    const [interval, setInterval] = useState(15)
    const [timeFormat, setTimeFormat] = useState('s')
    const [startTime, setStartTime] = useState(0)
    const [endTime, setEndTime] = useState(p_.page.duration)
    const [page, setPage] = useState(null)
    const [content, setContent] = useState(null)

    const getMilliseconds = () => {
        switch (timeFormat) {
            case 's':
                return 1000
            case 'm':
                return 60000
            case 'h':
                return 3600000
            default:
                return 1000
        }
    }

    const calculateContentCount = () => {
        if (page && content) {
            const pageDuration = page.duration
            const contentDuration = content.duration
            const selectedTimelineDuration = endTime - startTime
            const result =
                (playback === 'manualSettings' ? selectedTimelineDuration : pageDuration) /
                (contentDuration + interval * getMilliseconds())

            return Math.trunc(result)
        }

        return 0
    }

    const onApply = () => {
        editor.repeatClonedContentInterval(
            content,
            p_.selectedContent,
            interval * getMilliseconds(),
            calculateContentCount() - 1,
            startTime
        )

        onClose()
    }

    const convertMilliseconds = (ms) => {
        const hours = Math.floor(ms / 3600000)
        ms %= 3600000
        const minutes = Math.floor(ms / 60000)
        ms %= 60000
        const seconds = Math.floor(ms / 1000)

        return {
            hours: hours < 10 ? '0' + hours : hours,
            minutes: minutes < 10 ? '0' + minutes : minutes,
            seconds: seconds < 10 ? '0' + seconds : seconds,
        }
    }

    const convertTimeStringToMs = (timeString) => {
        const splitTimeString = timeString.split(':')
        const hours = splitTimeString[0][0] === '0' ? splitTimeString[0][1] : splitTimeString[0]
        const minutes = splitTimeString[1][0] === '0' ? splitTimeString[1][1] : splitTimeString[1]
        const seconds = splitTimeString[2][0] === '0' ? splitTimeString[2][1] : splitTimeString[2]

        return hours * 3600000 + minutes * 60000 + seconds * 1000
    }

    useEffect(() => {
        if (p_.content && p_.page) {
            setPage(p_.page)
            setContent(p_.content[p_.selectedContent])
        }
    }, [p_])

    return (
        <div
            className={styles.frequencyModal}
            onClick={(e) => {
                e.preventDefault()
                e.nativeEvent.stopImmediatePropagation()
            }}
        >
            <div className={styles.frequencyModalInner}>
                <div className={styles.frequencyTitle}>{translate('contentShowFrequency')}</div>
                <div className={styles.frequencyRow}>
                    <div className={styles.frequencyCol}>{translate('pageDuration')}</div>
                    <div className={styles.frequencyCol}>{page && page.duration / 1000}</div>
                </div>
                <div className={styles.frequencyRow}>
                    <div className={styles.frequencyCol}>{translate('contentShowCount')}</div>
                    <div className={styles.frequencyCol}>{calculateContentCount()}</div>
                </div>
                <div className={styles.frequencyRow}>
                    <div className={styles.frequencyCol}>{translate('playContentEvery')}</div>
                    <div className={styles.frequencyCol}>
                        <Dropdown
                            id="repetitionIntervalMS"
                            type="hmsTime"
                            wrapperWidth={true}
                            isNotDropdown={false}
                            mod="withBorder"
                            options={[
                                { id: 5, name: 5 },
                                { id: 10, name: 10 },
                                { id: 15, name: 15 },
                                { id: 30, name: 30 },
                            ]}
                            indentSize={'mini'}
                            onChange={(value) => {
                                if (value.id) {
                                    setInterval(value.id)

                                    return
                                }

                                setInterval(value)
                            }}
                            onChangeTimeFormat={(value) => {
                                setTimeFormat(value)
                            }}
                            hmsState={{
                                h: timeFormat === 'h',
                                m: timeFormat === 'm',
                                s: timeFormat === 's',
                            }}
                            value={interval}
                            searchable={true}
                            notFilterOnSearch={true}
                            placeholderAsValue={true}
                            hideNotFound={true}
                        />
                    </div>
                </div>
                <div className={styles.frequencyRow}>
                    <div className={styles.frequencyCol}>{translate('startEndPlayback')}</div>
                    <div className={styles.frequencyCol}>
                        <Dropdown
                            value={playback}
                            options={[
                                { name: translate('fromStartToEndBroadcast'), id: 'fromStartToEnd' },
                                { name: translate('manualSettings'), id: 'manualSettings' },
                            ]}
                            onChange={function (selected) {
                                setPlayback(selected.id)
                            }}
                        />
                    </div>
                </div>
                {playback === 'manualSettings' && (
                    <div className={styles.frequencyRow}>
                        <div className={styles.frequencyCol}>
                            <div className={styles.frequencyColLabel}>{translate('startPlayback')}</div>
                            <SelectTime
                                time={{
                                    type: 'tel',
                                    id: 'startTime',
                                    mask: '99:99:99',
                                    value: (function () {
                                        const time = convertMilliseconds(startTime)
                                        return `${time.hours}:${time.minutes}:${time.seconds}`
                                    })(),
                                    noFocus: true,
                                }}
                                onChange={(value) => {
                                    setStartTime(convertTimeStringToMs(value))
                                }}
                            />
                        </div>
                        <div className={styles.frequencyCol}>
                            <div className={styles.frequencyColLabel}>{translate('endPlayback')}</div>
                            <SelectTime
                                time={{
                                    type: 'tel',
                                    id: 'startTime',
                                    mask: '99:99:99',
                                    value: (function () {
                                        const time = convertMilliseconds(endTime)
                                        return `${time.hours}:${time.minutes}:${time.seconds}`
                                    })(),
                                    noFocus: true,
                                }}
                                onChange={(value) => {
                                    setEndTime(convertTimeStringToMs(value))
                                }}
                            />
                        </div>
                    </div>
                )}
                <div className={styles.description}>{translate('contentFrequencyDescription')}</div>
                <div className={styles.buttons}>
                    <Button
                        mod={'withBorder'}
                        rounded="full_md"
                        indentSize="mini"
                        onClick={onClose}
                        className={styles.button}
                    >
                        {translate('close')}
                    </Button>
                    <Button
                        rounded="full_md"
                        indentSize="mini"
                        mod="fill"
                        onClick={onApply}
                        className={styles.button}
                        disabled={!calculateContentCount()}
                    >
                        {translate('apply')}
                    </Button>
                </div>
            </div>
        </div>
    )
}
